<template>
  <fragment>
    <td :style="showRow && indSuplemento === indexRow ? 'border: 0px solid black;' : ''">
      <v-menu
        v-model="menuFrom"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedFromDateFormatted"
            :label="$t('lbl.from')"
            class="mt-5"
            persistent-hint
            readonly
            v-bind="attrs"
            outlined
            dense
            :disabled="$store.state.app.onlyShow"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="suplementoCar.from"
          no-title
          :min="new Date(Date.now()).toISOString().substr(0, 10)"
          locale="es"
          :show-current="false"
          @input="
            menuFrom = false
            activeToDate()
          "
        ></v-date-picker>
      </v-menu>
      <!--<vc-date-picker
        v-model="suplementoCar.from"
        outlined
        dense
        :min-date="new Date()"
        mode="date"
        :model-config="modelConfig"
        width="auto"
        @input="activeToDate"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <v-text-field
            :label="$t('lbl.from')"
            outlined
            dense
            :value="inputValue"
            class="mt-5"
            v-on="inputEvents"
          >
          </v-text-field>
        </template>
      </vc-date-picker>-->
    </td>
    <td :style="showRow && indSuplemento === indexRow ? 'border: 0px solid black;' : ''">
      <v-menu
        v-if="suplementoCar.from"
        v-model="menuTo"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="computedToDateFormatted"
            :label="$t('lbl.to')"
            class="mt-5"
            persistent-hint
            readonly
            v-bind="attrs"
            outlined
            dense
            :disabled="$store.state.app.onlyShow"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="suplementoCar.to"
          no-title
          locale="es"
          :show-current="false"
          :min="
            $moment(suplementoCar.from)
              .add(1, 'day')
              .toDate()
              .toISOString()
              .substr(0, 10)
          "
          @input="menuTo = false"
        ></v-date-picker>
      </v-menu>
      <!--<vc-date-picker
        v-if="suplementoCar.from"
        v-model="suplementoCar.to"
        outlined
        dense
        :min-date="
          $moment(suplementoCar.from)
            .add(1, 'day')
            .toDate()
        "
        mode="date"
        width="auto"
        :model-config="modelConfig"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <v-text-field
            ref="dateTo"
            :label="$t('lbl.to')"
            outlined
            dense
            :value="inputValue"
            class="mt-5"
            v-on="inputEvents"
          >
          </v-text-field>
        </template>
      </vc-date-picker>-->
    </td>
  </fragment>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { mdiDeleteOutline, mdiMenuDown, mdiMenuRight } from '@mdi/js'

export default {
  props: {
    showRow: {
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-default-prop
    suplementoCar: {
      type: Object,
    },
    indSuplemento: {
      type: Number,
      default: 0,
    },
    indexRow: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      icons: {
        mdiDeleteOutline,
        mdiMenuDown,
        mdiMenuRight,
      },
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      modelTimeConfig: {
        type: 'string',
        mask: 'HH:mm',
      },
      model: {
        check: false,
      },
      tarifas: [],
      tarifasXKm: [],
      menuFrom: false,
      menuTo: false,
    }
  },
  computed: {
    ...mapState({
      onlyShow: state => state.app.onlyShow,
      suplementosContrateCar: state => state.app.suplementosContrateCar,
      categoryContrateCar: state => state.app.categoryContrateCar,
      marcasModeloContrateCar: state => state.app.marcasModeloContrateCar,
    }),
    computedFromDateFormatted() {
      return this.suplementoCar.from ? this.$moment(this.suplementoCar.from).format('D-MMM-YY') : ''
    },
    computedToDateFormatted() {
      return this.suplementoCar.to ? this.$moment(this.suplementoCar.to).format('D-MMM-YY') : ''
    },
  },
  methods: {
    ...mapMutations([
      'addSuplementoContrateCar',
      'deleteSuplementoContrateCar',
      'addPriceTarifaXKmSuplementoContrateCar',
      'deletePriceTarifaXKmSuplementoContrateCar',
    ]),
    activeToDate() {
      setTimeout(() => {
        this.menuTo = true
      }, 100)
    },
  },
}
</script>
